import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const ForgotPassword = ({ boxedLogo, boxedLogoLight, isLightTheme }) => {
  const location = useLocation();
  const accountBasePath = location.pathname.startsWith("/publishers")
    ? "/publishers"
    : "/advertisers";
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitted(false);

    if (!email) {
      setError("Please enter your email address.");
      return;
    }

    try {
      const response = await fetch("/password_resets", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setSubmitted(true);
      } else {
        setError(data.error || "Failed to send reset instructions. Please try again.");
      }
    } catch (err) {
      setError("Failed to send reset instructions. Please try again.");
    }
  };

  return (
    <div className="sign-up-wrapper rainbow-section-gap">
      <div className="sign-up-box bg-flashlight">
        <div className="signup-box-top top-flashlight light-xl">
          <img
            className={`boxed-logo ${
              isLightTheme ? "boxed-logo-dark" : "boxed-logo-light"
            }`}
            src={isLightTheme ? boxedLogo : boxedLogoLight}
            width={180}
            alt="forgot-password logo"
          />
        </div>
        <div className="separator-animated animated-true"></div>
        <div className="signup-box-bottom">
          <div className="signup-box-content">
            <h4 className="title">Forgot Password</h4>
            {submitted ? (
              <div className="alert alert-success">
                If an account exists for <b>{email}</b>, you'll receive reset
                instructions shortly.
              </div>
            ) : (
              <form autoComplete="off" onSubmit={handleSubmit}>
                <div className="input-section mail-section">
                  <div className="icon">
                    <i className="feather-mail"></i>
                  </div>
                  <input
                    type="email"
                    placeholder="Enter your email address"
                    autoComplete="off"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                {error && <div className="alert alert-danger">{error}</div>}
                <button type="submit" className="btn-default">
                  Send Reset Link
                </button>
              </form>
            )}
          </div>
          <div className="signup-box-footer">
            <div className="bottom-text">
              <Link className="btn-read-more ps-2" to={`${accountBasePath}/sign-in`}>
                <span>Back to Sign In</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
